<div class="premium-locker-codes-container">
  <div class="premium-locker-codes-wrapper">
    <div class="inner-wrapper">
      <div class="modal-inner-container" id="modalInnerContainer">
        <div class="header-container">
          <div class="modal-header">
            <p class="desc">{{ header | translate }}</p>
            <h3 class="text">{{ 'view_translations.codes_per_page'| translate }}</h3>
          </div>
        </div>
      </div>
      <div class="content-wrapper" *ngIf="isLoaded; else loader">
        <ng-container *ngIf="isOfferwall" [ngTemplateOutlet]="offerWallDisclaimer"></ng-container>
        <ng-container [ngTemplateOutlet]="domainSelection"></ng-container>
        <ng-container [ngTemplateOutlet]="isOfferwall ? offerWallAdditionalFields : additionalFields"></ng-container>
        <ng-container [ngTemplateOutlet]="iframeUrl"></ng-container>
        <ng-container [ngTemplateOutlet]="iframeCode"></ng-container>
      </div>
      <div class="footer">
        <div class="primary-btn">
          <app-primary-button [buttonText]="'close'" [icon]="''" [iconSize]="12" [background]="'orange'" (emitAction)="close()"></app-primary-button>
        </div>
      </div>
      <button class="btn close-button" (click)="close()">
        <nb-icon icon="cross" pack="icomoon" class="cross-icon"></nb-icon>
      </button>
    </div>
  </div>
</div>

<!-- Offerwall disclaimer -->

<ng-template #offerWallDisclaimer>
  <div class="single-section">
    <h4 class="fontsize20 font700">Player ID</h4>
    <p class="code-desc fontsize16 font500">{{'player_id_desc' | t}}</p>
  </div>
</ng-template>

<!-- Domain selection section -->
<ng-template #domainSelection>
  <div class="single-section">
    <app-domain-selection [dropdownData]="domains" (emitSelectedValues)="onSelectDomain($event)"></app-domain-selection>
  </div>
</ng-template>

<!-- Fields for 'contentlocker' | 'captchalocker' | 'filelocker' | 'mobileRewards' -->
<ng-template #additionalFields>
  <div class="single-section checkboxes">
    <h4 class="fontsize20 font700">{{'view_translations.js_code' | translate}}</h4>
    <p class="code-desc fontsize16 font500">{{'view_translations.cl_code_info' | translate}}</p>
    <app-code-options-checkboxes
      (emitCheckAction)="onCheckCodeOption($event)"
      (emitParamsValue)="getParameterValue($event)"
      [options]="availableCodeOptions"></app-code-options-checkboxes>
  </div>
  <div class="single-section" *ngIf="codes.javascript_code">
    <h4 class="fontsize20 font700">{{'view_translations.js_code_that_you_can_paste' | translate}}</h4>
    <app-code-copy-panel [code]="codes.javascript_code"></app-code-copy-panel>
  </div>
</ng-template>

<!-- Fields for offerwall -->
<ng-template #offerWallAdditionalFields>
  <div class="single-section checkboxes">
    <h4 class="fontsize20 font700">{{'additional_options' | t}}</h4>
    <p class="code-desc fontsize16 font500">{{'owr_code_info' | t}}</p>
    <app-code-options-checkboxes
      (emitCheckAction)="onCheckCodeOption($event)"
      (emitParamsValue)="getParameterValue($event)"
      [options]="availableCodeOptions"></app-code-options-checkboxes>
  </div>
</ng-template>

<!-- Iframe url section -->
<ng-template #iframeUrl>
  <div class="single-section" *ngIf="codes.iframe_url">
    <h4 class="fontsize20 font700">{{'view_translations.url_for_your_iframe_code' | translate}}</h4>
    <app-code-copy-panel [code]="codes.iframe_url"></app-code-copy-panel>
  </div>
</ng-template>

<!-- Iframe code section -->
<ng-template #iframeCode>
  <div class="single-section last" *ngIf="codes.iframe_code">
    <h4 class="fontsize20 font700">{{'view_translations.sample_iframe_embed_code' | translate}}</h4>
    <app-code-copy-panel [code]="codes.iframe_code"></app-code-copy-panel>
  </div>
</ng-template>

<!-- Loader -->
<ng-template #loader>
  <div class="loader">
    <app-loader></app-loader>
  </div>
</ng-template>
